import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import App from 'App'
import { routes } from 'routes'
import NotFound from 'views/not-found'

const AppRoutes = (): JSX.Element => (
  <Router>
    <Routes>
      <Route element={<App />}>
        <Route path="*" element={<NotFound />} />
        {routes.map(({ path, element: Element, nested: nestedRoute }) => (
          <Route
            key={Array.isArray(path) ? path[0] : path}
            path={path}
            element={Element}
          >
            {nestedRoute && (
              <Route
                key={
                  Array.isArray(nestedRoute.path)
                    ? nestedRoute.path[0]
                    : nestedRoute.path
                }
                path={nestedRoute.path}
                element={nestedRoute.element}
              />
            )}
          </Route>
        ))}
      </Route>
    </Routes>
  </Router>
)

export default AppRoutes
